export interface AnalysisSummary {
  id: string;
  label: string;
  /**
   * `false` = geometría todavía no cerrada/validada, o cerrada pero con
   * un defecto documentado que la descalifica (ver auditoría de
   * route-builder-workspace) — la línea aparece en el catálogo del Hub
   * municipal, pero sin link funcional ni datos empaquetados. Nunca
   * expone el estado técnico interno (`CLOSURE_MANUAL_TRACE_FINAL`,
   * `CHECKPOINT_ROUTER_DRAFT`, etc.) en esta capa — eso queda en
   * provenance/auditoría, acá solo Disponible/No disponible.
   */
  available: boolean;
}

/**
 * Catálogo COMPLETO de líneas de Bahía Blanca, ordenado por número —
 * disponibles y no disponibles. La misma lista alimenta las cards de
 * `AnalysisHubPage` y, por `id`, el título que `AnalysisViewerPage`
 * muestra mientras el bundle todavía no cargó. El backend sigue siendo
 * la fuente de verdad de qué `analysisId` existe realmente
 * (`frozen-data-registry.ts`) — las líneas `available: false` acá NO
 * tienen entrada en ese registry ni paquete en `frozen-data/`.
 *
 * Universo de líneas verificado contra la fuente municipal autoritativa
 * (GPKG combinado — `Suite/Archivos para Importar/...gpkg`, consolidado en
 * `route-builder-workspace/21-rutas-oficiales.geojson`: 21 features, 17
 * líneas distintas), NO inferido de qué archivos existen en el workspace.
 * Campaña geométrica cerrada 2026-08-24: 21/21 rutas (17/17 códigos de
 * línea) con `status=CLOSURE_MANUAL_TRACE_FINAL` — las 17 están
 * disponibles. Para 503/507/517/519A (ramales con variante nombrada:
 * Corto UNS Palihue / Prolongación Espora / Rondín / Rondín) se empaquetó
 * la geometría "(principal)" — la variante nombrada existe cerrada en el
 * workspace pero no se expone como entrada de Hub separada, mismo
 * criterio ya usado para 503 antes de este cierre.
 */
export const BAHIA_BLANCA_ANALYSES: readonly AnalysisSummary[] = [
  { id: 'linea-500', label: 'Línea 500', available: true },
  { id: 'linea-502', label: 'Línea 502', available: true },
  { id: 'linea-503', label: 'Línea 503', available: true },
  { id: 'linea-504', label: 'Línea 504', available: true },
  { id: 'linea-505', label: 'Línea 505', available: true },
  { id: 'linea-506', label: 'Línea 506', available: true },
  { id: 'linea-507', label: 'Línea 507', available: true },
  { id: 'linea-509', label: 'Línea 509', available: true },
  { id: 'linea-512', label: 'Línea 512', available: true },
  { id: 'linea-513', label: 'Línea 513', available: true },
  { id: 'linea-513ex', label: 'Línea 513ex', available: true },
  { id: 'linea-514', label: 'Línea 514', available: true },
  { id: 'linea-516', label: 'Línea 516', available: true },
  { id: 'linea-517', label: 'Línea 517', available: true },
  { id: 'linea-518', label: 'Línea 518', available: true },
  { id: 'linea-519', label: 'Línea 519', available: true },
  { id: 'linea-519a', label: 'Línea 519A', available: true },
];

export function findAnalysisLabel(analysisId: string): string {
  return BAHIA_BLANCA_ANALYSES.find(a => a.id === analysisId)?.label ?? analysisId;
}
